import React from 'react';
import { Tag } from 'antd';
import { ShipmentCommercialInvoiceDetailStatus } from '@xbcb/shipment-types';
import { safeGetMessage } from '@xbcb/ui-utils';
import { useBundle } from '@amzn/react-arb-tools';

export interface ShipmentStatusProps {
  status?: ShipmentCommercialInvoiceDetailStatus;
}

const ShipmentStatus: React.FC<ShipmentStatusProps> = ({ status }) => {
  const [bundle] = useBundle('components.ShipmentStatus');
  const validationFailedMessage = safeGetMessage(
    bundle,
    'shipment_validation_failed',
    {},
    'Seller Documents Rejected',
  );

  const hasErrorStatus =
    status === ShipmentCommercialInvoiceDetailStatus.VALIDATION_FAILED;

  if (!status) return null;

  return (
    <div>
      <Tag color={hasErrorStatus ? 'red' : undefined}>
        {hasErrorStatus ? validationFailedMessage : '1CC'}
      </Tag>
    </div>
  );
};

export default ShipmentStatus;
